import { push } from 'connected-react-router';
import get from 'lodash/get';
import { generatePath } from 'bento-ordering/utils/generatePath';
import { MENU } from 'bento-ordering/menus/constants/entities';
import { getBaseMenuPathForLocation } from 'bento-ordering/menus/selectors';
import { closeNotificationModal } from 'bento-ordering/base/actions/notificationModals';
import { getItemByIdSelector } from 'bento-ordering/base/reducers/bentoApi';
import { isMobileMedia } from 'bento-ordering/utils/media';
import { openModal } from 'bento-ordering/base/actions/modal';

export const goToOrderSettings = () => (dispatch, getState) => {
  const state = getState();
  const onlineOrderingLocation = state.cart.online_ordering_location;
  const selectedLocation = getItemByIdSelector(
    state.restaurantLocations,
    onlineOrderingLocation
  );

  if (onlineOrderingLocation) {
    const path = generatePath(MENU, 'orderSetting', {
      slug: get(selectedLocation, 'location.slug')
    });

    if (!isMobileMedia()) {
      dispatch(openModal());
    }

    dispatch(closeNotificationModal());
    return dispatch(push(path));
  }
};

export const goToMenu = () => (dispatch, getState) => {
  const state = getState();
  const onlineOrderingLocation = state.cart.online_ordering_location;

  if (onlineOrderingLocation) {
    const path = getBaseMenuPathForLocation(state);
    dispatch(closeNotificationModal());
    return dispatch(push(path));
  }
};
